module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_location_photowedding@2x-28eb32903642c105e3ef49a954123fa4.webp";